import { SuperBillFilterData } from "../../../../billings/SuperBillFilter";

type Option = { value: string; label: string };

export type PatientClaimsFilterData = {
  claim_statuses: Option[] | undefined;
  claim_types: Option[] | undefined;
};

export const DEFAULT_PATIENT_CLAIMS_FILTERS: PatientClaimsFilterData = {
  claim_statuses: undefined,
  claim_types: undefined,
};

export type FinancialOutletContext = {
  invoiceSearchKey: string;
  invoiceFilter: SuperBillFilterData;
  claimsSearchKey: string;
  claimsFilter: PatientClaimsFilterData;
};
